<div class="history-container">
  <mat-card class="no-shadow">
    <mat-card-header>
      <mat-card-title class="no-subtitle"> Pilot History </mat-card-title>
      <mat-card-title>
        <button
          mat-icon-button
          color="primary"
          (click)="dialog.closeAll()"
          tabindex="-1"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      @if (history$ | async; as history) {
        @if (history.isLoading && !history.response) {
          <div class="width-100 flex-center">
            <mat-spinner color="accent" [diameter]="32"></mat-spinner>
          </div>
        }
        @if (history.response?.items && history.response!.items.length > 0) {
          <!-- Just subscribes to name lookup if needed -->
          @if (nameLookup$ | async; as nameLookup) {
            <div class="text-base mb-32 mt-16 name-row">
              <span>Your flight history with</span>
              @if (nameLookup.isLoading) {
                <span>
                  <mat-spinner color="accent" [diameter]="24"></mat-spinner>
                </span>
              }
              @if (
                nameLookup.response &&
                nameLookup.response.list &&
                nameLookup.response.list.length > 0
              ) {
                <span class="font-medium accent-color">
                  {{
                    nameLookup.response.list[0].nickName ||
                      nameLookup.response.list[0].firstName | titlecase
                  }}
                  {{ nameLookup.response.list[0].lastName }}
                </span>
              }
              @if (!nameLookup.isLoading && !nameLookup.response) {
                <span>?</span>
              }
            </div>
          } @else {
            <div class="text-base mb-32 mt-16">
              Your flight history with
              <span class="font-medium accent-color">
                {{ name | titlecase }}:
              </span>
            </div>
          }
          <app-data-box headerTitle="History">
            <div class="data-box-content text-sm">
              @if (
                (history.response && history.response.hasNext) ||
                history.response!.page > 0
              ) {
                <div class="page-controls">
                  <button
                    mat-icon-button
                    (click)="onPageClick(history.response!.page - 1)"
                    [disabled]="history.response!.page === 0"
                    color="primary"
                    tabindex="-1"
                  >
                    <mat-icon>arrow_back_ios</mat-icon>
                  </button>
                  <div class="text-center text-sm">
                    Page {{ history.response!.page + 1 }}
                  </div>
                  <button
                    mat-icon-button
                    (click)="onPageClick(history.response!.page + 1)"
                    [disabled]="!history.response?.hasNext"
                    color="primary"
                    tabindex="-1"
                  >
                    <mat-icon>arrow_forward_ios</mat-icon>
                  </button>
                </div>
              }
              @for (seq of history.response?.items; track $index) {
                <mat-expansion-panel class="exp-panel">
                  <mat-expansion-panel-header tabIndex="-1">
                    <mat-panel-title>
                      <div class="seq-title">
                        <div>
                          <div class="text-center">
                            {{ formatDate(seq.originationDate) }}
                          </div>
                          <div class="label-4 text-center">Date</div>
                        </div>
                        <div>
                          <div class="text-center">
                            {{ seq.sequenceNumber }}
                          </div>
                          <div class="label-4 text-center">Seq</div>
                        </div>
                        <div>
                          <div class="text-center">
                            {{ seq.seat }}
                          </div>
                          <div class="label-4 text-center">Seat</div>
                        </div>
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="table-container">
                    <table class="width-100">
                      <thead>
                        <th>Date</th>
                        <th>Flt</th>
                        <th>Dep/Arr</th>
                        <th>Acft</th>
                      </thead>
                      <tbody>
                        @for (dp of seq.dutyPeriodSummaries; track $index) {
                          @for (leg of dp.legs; track $index) {
                            <tr>
                              <td class="text-base">
                                {{
                                  $index === 0
                                    ? formatDate(leg.departure.actual.local)
                                    : ""
                                }}
                              </td>
                              <td class="text-base font-thin">
                                {{ leg.flightNumber }}
                              </td>
                              <td class="text-base">
                                {{ leg.departureStation.code }}-{{
                                  leg.arrivalStation.code
                                }}
                              </td>
                              <td class="text-base opacity-6">
                                {{ leg.aircraft.type.short }}
                              </td>
                            </tr>
                          }
                        }
                      </tbody>
                    </table>
                  </div>
                </mat-expansion-panel>
              }
            </div>
          </app-data-box>
          <div class="text-xs opacity-6 m-16 text-center">
            <span class="font-medium">Note:</span> Ability to add notes will be
            added in the future.
          </div>
        } @else if (!history.isLoading && !history.response) {
          <div class="text-base warn-color p-16">
            Unable to fetch pilot history.
          </div>
        } @else if (history.response && history.response.items.length === 0) {
          <!-- Just subscribes to name lookup if needed -->
          @if (nameLookup$ | async; as nameLookup) {
            @if (
              nameLookup.response &&
              nameLookup.response.list &&
              nameLookup.response.list.length === 0
            ) {
              <div class="text-base mb-32 mt-16">Employee number not found</div>
            } @else {
              <div class="text-base mb-32 mt-16 name-row">
                <span>You haven't flown with</span>
                @if (nameLookup.isLoading) {
                  <span>
                    <mat-spinner color="accent" [diameter]="24"></mat-spinner>
                  </span>
                }
                @if (
                  nameLookup.response &&
                  nameLookup.response.list &&
                  nameLookup.response.list.length > 0
                ) {
                  <span class="font-medium accent-color">
                    {{
                      nameLookup.response.list[0].nickName ||
                        nameLookup.response.list[0].firstName | titlecase
                    }}
                    {{ nameLookup.response.list[0].lastName }}
                  </span>
                }
                @if (!nameLookup.isLoading && !nameLookup.response) {
                  <span>?</span>
                }
              </div>
            }
          } @else if (name) {
            <div class="text-base p-16">
              You haven't flown with
              <span *ngIf="name" class="font-medium accent-color">
                {{ name | titlecase }}
              </span>
            </div>
          } @else {
            <div class="text-base p-16 warn-color">Name missing</div>
          }
        }
      }
      <mat-divider></mat-divider>
      <!-- Search bar -->
      <div>
        <form
          [formGroup]="searchForm"
          (ngSubmit)="onSearchClick()"
          class="emp-num-search"
        >
          <mat-form-field appearance="outline" class="mt-16 width-100">
            <mat-label>Search by employee #</mat-label>
            <input
              matInput
              type="search"
              inputmode="numeric"
              (input)="numeric(searchForm.controls.empNum)"
              [minLength]="6"
              [maxLength]="6"
              tabindex="-1"
              formControlName="empNum"
            />
          </mat-form-field>
          <button
            mat-icon-button
            type="submit"
            color="primary"
            tabindex="-1"
            (click)="onSearchClick()"
          >
            <mat-icon matSuffix color="primary" (click)="onSearchClick()"
              >search</mat-icon
            >
          </button>
        </form>
      </div>
    </mat-card-content>
  </mat-card>
</div>
